module.exports = __webpack_public_path__ + "static/img/h8.d221627.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hor/h8.jpg
// module id = 6BZ0
// module chunks = 1